import styled, { css } from 'styled-components/macro';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { transition300ms } from '@yme/tokens/transitions';
import { buildSpecificIndent } from '@yme/utils/styles';
// Styles for common wrapper of Carousel
export const CarouselContentStyled = styled.div `
  overflow: hidden;

  ${buildSpecificIndent(INDENT.xs)}

  ${ADAPTIVE.minWidth.tablet} {
    ${buildSpecificIndent(INDENT.sm)}
  }

  ${ADAPTIVE.minWidth.desktop} {
    ${buildSpecificIndent(INDENT.none)}
  }
`;
// Styles for inner of Carousel
export const CarouselScrollableContentStyled = styled.div `
  display: flex;
  flex-direction: row;

  gap: ${({ getterSize }) => getterSize && `${getterSize}px`};

  transform: ${({ transformLeft }) => `translate3d(${transformLeft}px, 0px, 0px)`};
  transition: ${transition300ms};
`;
export const HeaderCarouselStyled = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  align-content: center;

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  margin-bottom: ${INDENT.sm};

  ${ADAPTIVE.minWidth.desktop} {
    margin-bottom: ${INDENT.m};
  }
`;
// Arrow styles (in header Carousel)
export const ArrowNavStyled = styled.div `
  display: flex;
  align-items: center;
  align-content: center;
  flex-wrap: nowrap;
  gap: 12px;
`;
// styles for Item Carousel content spot
export const ItemCarouselStyled = styled.div `
  display: flex;
  flex-direction: column;

  cursor: ${({ isDraggable }) => (isDraggable ? 'grabbing' : 'grab')};

  ${({ carouselConfig }) => css `
    width: ${carouselConfig?.sm?.width || 'auto'};
    min-width: ${carouselConfig?.sm?.width || 'auto'};

    ${ADAPTIVE.minWidth.tablet} {
      ${carouselConfig?.md?.width &&
    css `
        width: ${carouselConfig.md.width};
        min-width: ${carouselConfig.md.width};
      `};
    }

    ${ADAPTIVE.minWidth.desktop} {
      ${carouselConfig?.lg?.width &&
    css `
        width: ${carouselConfig.lg.width};
        min-width: ${carouselConfig.lg.width};
      `};
    }
  `}
`;
export const DotsWrapperStyled = styled.div `
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  object-position: center;

  margin-top: ${INDENT.sm};

  ${ADAPTIVE.minWidth.tablet} {
    margin-top: ${INDENT.m};
  }
`;
